var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetstarted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.227,
    height: 25.229,
    viewBox: "0 0 25.227 25.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.163 -15.117)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.316 15.269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.759,20.019l.467-3.518a1.077,1.077,0,0,0-1.221-1.221l-3.518.467A10.806,10.806,0,0,0,29.312,18.8l-2.154,2.154a9.729,9.729,0,0,0-7.647,1.616l-1.292.933a1.077,1.077,0,0,0,.287,1.9l3.159,1.077-.251.251a1.8,1.8,0,0,0-.144,2.334l-2.226,2.226a.718.718,0,0,0-.144.826l-3.554,7.575a.359.359,0,0,0,.323.5h.144l7.575-3.554.323.072a.718.718,0,0,0,.5-.215l2.226-2.226a1.8,1.8,0,0,0,2.334-.144l.251-.251L30.1,37.036a1.077,1.077,0,0,0,.862.718h.144a1.077,1.077,0,0,0,.862-.467L32.938,36a9.693,9.693,0,0,0,1.616-7.647l2.154-2.154a10.842,10.842,0,0,0,3.052-6.175Zm-21.038,4.7a.359.359,0,0,1-.108-.646l1.292-.933a9.011,9.011,0,0,1,6.606-1.58L22.2,25.907Zm.682,7.97L22.814,36.1l-6.39,2.98Zm4.308,3.267-4.2-4.165L21.7,29.6l4.2,4.165Zm8.652-.431-.933,1.292a.368.368,0,0,1-.646-.108L29.6,33.231l4.344-4.272a9.011,9.011,0,0,1-1.58,6.606ZM28.271,33.59a1.113,1.113,0,0,1-1.508,0l-4.847-4.811a1.077,1.077,0,0,1,0-1.508l7.934-7.9a10.088,10.088,0,0,1,5.78-2.872l3.518-.467h.036a.359.359,0,0,1,.359.395l-.467,3.518a10.124,10.124,0,0,1-2.872,5.78Z",
    transform: "translate(-15.316 -15.269)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.722,32.5a2.549,2.549,0,1,0,1.8.754A2.549,2.549,0,0,0,55.722,32.5Zm1.328,3.877a1.831,1.831,0,1,1,.539-1.292,1.831,1.831,0,0,1-.539,1.292Z",
    transform: "translate(-39.573 -26.314)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetstarted);
export default __webpack_public_path__ + "static/media/getstarted.a658c955.svg";
export { ForwardRef as ReactComponent };